import type {Product} from '@shopify/hydrogen/storefront-api-types';
import {ProductCard, Section} from '~/components';

const mockProducts = new Array(12).fill('');

export function ProductSwimlane({
  title = 'Featured Products',
  products = mockProducts,
  count = 12,
  ...props
}: {
  title?: string;
  products?: Product[];
  count?: number;
}) {
  return (
    <div className="shop-area ptb-80">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-12 services-content">
            <div className="section-title">
              <h2>{title}</h2>
              <div className="bar"></div>
            </div>
          </div>
          {products.map((product) => (
            <ProductCard
              product={product}
              key={product.id}
              className="snap-start w-80"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
